<template>
  <base-panel
    :asset="asset"
    :hide-print-button="false"
    :asset-module="assetModule"
    :tabs="tabs"
    :last-update="lastUpdate"
    :notifications="notifications"
  />
</template>

<script>
import CommutatorDifferentialTabs from '@/domain/enums/installation/engineering/commutatorTemperatureDifferential/commutatorTemperatureDifferentialTabs';
import BasePanel from '@/domain/components/installation/engineering/BasePanel';
import GeneralTab from '@/domain/components/installation/engineering/commutatorTemperatureDifferential/GeneralTab';
import ChartsTab from '@/domain/components/installation/engineering/commutatorTemperatureDifferential/ChartsTab';
import ParametersTab from '@/domain/components/installation/engineering/commutatorTemperatureDifferential/ParametersTab';
import Service from '@/domain/services/installation/engineering/commutatorTemperatureDifferential/commutatorTemperatureDifferentialService';
import eventBus from '@/services/globalEventBus';
import LoadingMixin from '@/services/loadingMixin';
import events from '@/domain/events/engineering';

export default {
  name: 'CommutatorTemperatureDifferential',
  props: {
    asset: {
      type: Object,
      default: () => ({}),
    },
    assetModule: {
      type: Object,
      default: () => ({}),
    },
    notifications: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [LoadingMixin],
  components: {
    BasePanel,
  },
  data: () => ({
    commutatorsAmount: null,
    lastUpdate: '',
  }),
  computed: {
    tabs() {
      return [
        {
          name: CommutatorDifferentialTabs.GENERAL,
          title: this.$t('general.general'),
          component: GeneralTab,
          commutatorsAmount: this.commutatorsAmount,
        },
        {
          name: CommutatorDifferentialTabs.PARAMETERS,
          title: this.$t('general.parameters'),
          component: ParametersTab,
          commutatorsAmount: this.commutatorsAmount,
          showTooltip: true,
          tooltipMessage: 'messages.MI023.message',
        },
        {
          name: CommutatorDifferentialTabs.CHART,
          title: this.$t('general.chart'),
          component: ChartsTab,
          commutatorsAmount: this.commutatorsAmount,
        },
      ];
    },
  },
  created() {
    this.getCommutatorStatus(true);
    this.initListener();
  },
  beforeDestroy() {
    this.removeListener();
  },
  methods: {
    getCommutatorStatus(showLoading) {
      return Service.getStatus(this.assetModule.id).then((response) => {
        this.commutatorsAmount = response.commutatorsAmount;
        this.lastUpdate = response.lastUpdate;
      }).then(() => {
        eventBus.emit(events.refreshDataTab, showLoading);
      }).catch(() => {
        this.commutatorsAmount = 0;
      });
    },
    initListener() {
      eventBus.on(events.refreshData, this.refreshDataEvent, this);
    },
    removeListener() {
      eventBus.off(events.refreshData, this.refreshDataEvent, this);
    },
    refreshDataEvent({ wait }) {
      wait(this.getCommutatorStatus());
    },
  },
};
</script>

<style lang="sass" scoped>
  @media print
    ::v-deep .tabs > .tab-content > .tab-pane
      border-bottom: none
</style>
